module.exports = __webpack_public_path__ + "img/img_actbar@2x.21fedd9f.png";